import React from 'react';
import TemplateDipendenze from '../../components/template-dipendenze';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const DipendenzePreview = (props) => {
  const name = getProp(props, 'name');
  const image = getPropAsset(props, 'image');
  const description = getPropMarked(props, 'description');
  return <TemplateDipendenze dipendenze={[{ name, image, description }]} preview={true} />;
};

export default DipendenzePreview;
